import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Deliverables } from './components/Deliverables';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Author } from './components/Author';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full min-h-full bg-cream font-sans antialiased" data-id="element-0" data-mp="28suumo7jhzm9">
      <MetaPixel data-id="element-1" data-mp="23w4g45bdvc2y" />
      <main className="w-full overflow-x-hidden" data-id="element-2" data-mp="23ujjma5idj2g">
        <Hero data-id="element-3" data-mp="3ijxo6nd1puib" />
        <BeforeAfter data-id="element-4" data-mp="3ikh7o8icgqyg" />
        <PainPoints data-id="element-5" data-mp="3iiwfuqnezm4a" />
        <Volumes data-id="element-6" data-mp="3ijftvw9y1qd1" />
        <Deliverables data-id="element-7" data-mp="3ihuyy5jpw5en" />
        <Bonuses data-id="element-8" data-mp="3mlaxx8j9ehui" />
        <Offer data-id="element-9" data-mp="3mkrbpfmkt7ao" />
        <Guarantee data-id="element-10" data-mp="3mk85uxa7a9d0" />
        <Testimonials data-id="element-11" data-mp="3mjq2zht18ww4" />
        <Author data-id="element-12" data-mp="3mj6lu3b7icj5" />
        <Faq data-id="element-13" data-mp="3rcj31sdk3h1v" />
        <FinalCta data-id="element-14" data-mp="3rbzomln47asl" />
      </main>
      <Footer data-id="element-15" data-mp="3rcsxbs5mwadd" />
      <FloatingCta startAfterId="first-cta" data-id="element-16" data-mp="3recd7hndojem" />
      <PurchasePopup data-id="element-17" data-mp="67znpl2q47d" />
    </div>;
}